// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-comment-input{position:relative;display:grid;grid-template-columns:auto 32px;grid-gap:4px;align-items:center}.add-comment-input .v-input__append-inner{margin-top:2px!important}.add-comment-input .message-input__emoji-button{max-width:40px;min-width:40px!important;padding:0!important;height:auto}", ""]);
// Exports
module.exports = exports;
